import { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { PageContextWrapper } from "@ryde/controls";
import { COURSES_CALENDAR_URL_PATH } from "@ryde/shared";

import { CoursesPageGrid } from "./grid";
import { CoursesCalendarPageMain } from "./main";

export const CoursesPage: FC = () => {
  return (
    <PageContextWrapper entity="course">
      <Routes>
        <Route
          path={`${COURSES_CALENDAR_URL_PATH}/*`}
          element={<CoursesCalendarPageMain />}
        />
        <Route path="/*" element={<CoursesPageGrid />} />
      </Routes>
    </PageContextWrapper>
  );
};
